// extracted by mini-css-extract-plugin
module.exports = {"tpLogoMenu":"home_tpLogoMenu__UTuSZ","loginButtons":"home_loginButtons__2cv2R"};